import { AxiosInstance, AxiosResponse } from "axios";
import { ApiResponse } from "../public-types";
import { PartnerInformationResponse } from "./partner-types";

/**
 * TPA01. 계약 이용자 파트너 정보 조회
 */
export async function getPartnerInformationAsync(
  axios: AxiosInstance,
  params?: {
    contractId: string | number;
  },
): Promise<AxiosResponse<ApiResponse<PartnerInformationResponse>>> {
  if (params?.contractId === undefined || params?.contractId === null || params?.contractId === "") {
    throw Error("contractId is not found.");
  }
  return await axios.get(`/api/court/pa/contracts/${params.contractId}/partner`);
}
